import { render, staticRenderFns } from "./NYTCard.vue?vue&type=template&id=47dbae7a&scoped=true"
import script from "./NYTCard.vue?vue&type=script&lang=js"
export * from "./NYTCard.vue?vue&type=script&lang=js"
import style0 from "./NYTCard.vue?vue&type=style&index=0&id=47dbae7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dbae7a",
  null
  
)

export default component.exports